import { VStack, StackProps, Text } from "@chakra-ui/react";
import TinyHeading from "components/TinyHeading";
import { NftAttribute } from "types";

type AttributeProps = StackProps & {
  attribute: NftAttribute;
};

const Attribute = ({ attribute, ...rest }: AttributeProps) => (
  <VStack
    bg="bright.300"
    p="3"
    spacing="1"
    align="start"
    overflow="hidden"
    {...rest}
  >
    <TinyHeading opacity="0.6" color="dark.500">
      {attribute.trait_type}
    </TinyHeading>
    <Text lineHeight="1.25" isTruncated>
      {attribute.display_type === "date"
        ? new Date(+attribute.value).toLocaleDateString()
        : attribute.value}
    </Text>
  </VStack>
);

export default Attribute;
